// LXRA Marketplace add-ons: Availability calendar (Phase 5.2) + Reviews & Ratings (Phase 5.3)

export const REVIEW_PAGE = {
  root: 'review-page',
  invalid: 'review-invalid-state',
  alreadyReviewed: 'review-already-submitted-state',
  starInput: 'review-star-rating-input',
  commentInput: 'review-comment-input',
  submitButton: 'review-submit-button',
  success: 'review-success-state',
};
